// THIS IS A GENERATED FILE, DO NOT EDIT IT!

      export interface PossibleTypesResultData {
        possibleTypes: {
          [key: string]: string[]
        }
      }
      const result: PossibleTypesResultData = {
  "possibleTypes": {
    "ContainerAccountLink": [
      "BargeAccountLink",
      "GrainBinAccountLink",
      "PileAccountLink"
    ],
    "FanControllerRequest": [
      "FanControllerDiagnosticTestRequest",
      "FanControllerPingRequest",
      "FanControllerResetRequest",
      "FanControllerSetConfigRequest"
    ],
    "FanControllerResponse": [
      "FanControllerDebugResponse",
      "FanControllerDiagnosticTestCellMetricTestResultResponse",
      "FanControllerDiagnosticTestSelfTestResultResponse",
      "FanControllerDiagnosticTestStatusResponse",
      "FanControllerGetConfigResponse",
      "FanControllerHeartbeatResponse",
      "FanControllerResetResponse"
    ]
  }
};
      export default result;
    